import { DeviceInfo } from '../types'
import { isWeb } from '@/constants/environment'
import * as Device from 'expo-device'
import { Platform } from 'react-native'
import { UAParser } from 'ua-parser-js'

export const getDeviceInfo = (): DeviceInfo => {
    let browserInfo = {}

    if (isWeb) {
        const { browser } = UAParser(navigator.userAgent)
        browserInfo = {
            browserName: browser.name,
            browserVersion: browser.version,
        }
    }

    return {
        deviceBrand: Device.brand || undefined,
        deviceModel: Device.modelName || undefined,
        osName: Device.osName || undefined,
        osVersion: Device.osVersion || undefined,
        platform: Platform.OS,
        ...browserInfo,
    }
}
